import UsersProxy from '@/proxies/Users';
import UsersTransform from '@/transforms/Users';
import * as types from './mutation-types';

export default {
  async create({ commit, dispatch }, payload) {
    try {
      commit(types.LOADING, true);
      const proxy = new UsersProxy();
      await proxy.create(payload);
      await dispatch('refresh');
      dispatch('notification/success', 'confirmationmessage.user_created', { root: true });
    } catch (e) {
      dispatch('notification/error', 'errormessage.failed_to_add_user', { root: true });
    } finally {
      commit(types.LOADING, false);
    }
  },

  async deleteItem({ commit, dispatch }, payload) {
    try {
      commit(types.LOADING, true);
      const users_ids = Array.isArray(payload) ? payload : [payload];
      const proxy = new UsersProxy();
      await proxy.delete({ users_ids });
      await dispatch('refresh');
      dispatch('notification/success', 'confirmationmessage.user_deleted', { root: true });
    } catch (e) {
      dispatch('notification/error', 'errormessage.failed_to_delete_user', { root: true });
    } finally {
      commit(types.LOADING, false);
    }
  },

  async getItems({ commit, dispatch }) {
    try {
      commit(types.LOADING, true);
      const proxy = new UsersProxy();
      const { total, users } = await proxy.getItems();
      commit(types.SET_ITEMS, UsersTransform.fetchCollection(users));
      commit(types.TOTAL, total);
    } catch (e) {
      dispatch('notification/error', 'errormessage.failed_to_get_users', { root: true });
    } finally {
      commit(types.LOADING, false);
    }
  },

  async refresh({ dispatch }) {
    await dispatch('getItems');
  },

  setSearchFilter({ commit }, payload) {
    commit(types.SET_SEARCH_FILTER, payload);
  },

  async update({ commit, dispatch }, payload) {
    try {
      commit(types.LOADING, true);
      const proxy = new UsersProxy();
      await proxy.update(payload.user_id, payload);
      await dispatch('refresh');
      dispatch('notification/success', 'confirmationmessage.user_updated', { root: true });
    } catch (e) {
      dispatch('notification/error', 'errormessage.failed_to_update_user', { root: true });
    } finally {
      commit(types.LOADING, false);
    }
  },
};
